import React from "react";
import OTPForm from "../component/Register/OTPForm";


const OTPVerificationPage = () => {


  return (
    <section className="text-gray-900 transition-colors bg-bg-light-primary dark:bg-bg-dark-primary dark:text-gray-100">
      {/* <HeaderLayout relative={true} /> */}
      <div className="">
        <OTPForm />
      </div>
      {/* < /> */}
    </section>
  );
};

export default OTPVerificationPage;
